module.exports = __webpack_public_path__ + "static/instruction3.fed2d80a.svg";